// extracted by mini-css-extract-plugin
export default {"container_grid":"ImagesGrid_container_grid__1sLa0","home_grid":"ImagesGrid_home_grid__2rG0Q","home_img_card":"ImagesGrid_home_img_card__2bWMZ"};